import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType} from '@/lib/react-query';

import { PetSettings } from '../types';
export const getPetSettings = (): Promise<PetSettings> => {
  return axios.get(`/ref-values`);
};


type QueryFnType = typeof getPetSettings;
export const useGetPetSettings = () => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['petSettings'],
    queryFn: () => getPetSettings(),
  });
};


